export class CatFeeEmployeejobModel {
    public feeEmployeeJobId?:number;
    public description?:string;
    public employeeJobId?:number;
    public minFee?:number;
    public maxFee?:number;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}